import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Linkedin, Instagram, Facebook } from 'lucide-react';
import { QRCodeSVG } from 'qrcode.react';

const SITE_URL = 'https://barhamdriver.com';

const Footer = () => {
  return (
    <footer className="bg-[#0f0f10] text-white">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="block mb-4 sm:mb-6">
              <span className="text-xl sm:text-2xl font-bold" style={{ fontFamily: 'cursive' }}>
                Barham
              </span>
              <span className="block text-[10px] sm:text-xs tracking-widest text-gray-400 uppercase font-bold mt-1">
                DRIVER
              </span>
            </Link>
            <p className="text-gray-400 text-xs sm:text-sm leading-relaxed mb-4">
              VTC Chauffeur privé au Sénégal. Voiture électrique climatisée pour tous vos déplacements.
            </p>

            {/* QR Code */}
            <div className="bg-white p-3 rounded-lg inline-block">
              <QRCodeSVG
                value={SITE_URL}
                size={80}
                level="M"
                includeMargin={false}
                bgColor="#ffffff"
                fgColor="#0f0f10"
              />
            </div>
            <p className="text-gray-500 text-[10px] mt-2">Scannez pour réserver</p>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-xs sm:text-sm uppercase tracking-wider mb-4 sm:mb-6 font-medium">Nos Services</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link to="/services/simple-transfer" className="text-gray-400 text-xs sm:text-sm hover:text-white transition-colors">
                  Transfert simple
                </Link>
              </li>
              <li>
                <Link to="/services/airport-transfer" className="text-gray-400 text-xs sm:text-sm hover:text-white transition-colors">
                  Transfert aéroport
                </Link>
              </li>
              <li>
                <Link to="/services/hourly-service" className="text-gray-400 text-xs sm:text-sm hover:text-white transition-colors">
                  Mise à disposition
                </Link>
              </li>
              <li>
                <Link to="/fleet" className="text-gray-400 text-xs sm:text-sm hover:text-white transition-colors">
                  Notre flotte
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-xs sm:text-sm uppercase tracking-wider mb-4 sm:mb-6 font-medium">Entreprise</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link to="/contact" className="text-gray-400 text-xs sm:text-sm hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/destinations" className="text-gray-400 text-xs sm:text-sm hover:text-white transition-colors">
                  Destinations
                </Link>
              </li>
              <li>
                <Link to="/legal" className="text-gray-400 text-xs sm:text-sm hover:text-white transition-colors">
                  Mentions légales
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="col-span-2 md:col-span-1">
            <h4 className="text-xs sm:text-sm uppercase tracking-wider mb-4 sm:mb-6 font-medium">Contact</h4>
            <ul className="space-y-3 sm:space-y-4">
              <li>
                <a href="tel:+221774884254" className="flex items-center gap-3 group">
                  <Phone size={14} className="text-gray-500 group-hover:text-green-400 transition-colors" />
                  <span className="text-gray-400 text-xs sm:text-sm group-hover:text-white transition-colors">+221 77 488 42 54</span>
                </a>
              </li>
              <li>
                <a href="mailto:Sandierygassama8@gmail.com" className="flex items-center gap-3 group">
                  <Mail size={14} className="text-gray-500 group-hover:text-green-400 transition-colors" />
                  <span className="text-gray-400 text-xs sm:text-sm group-hover:text-white transition-colors break-all">Sandierygassama8@gmail.com</span>
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={14} className="text-gray-500 mt-0.5" />
                <span className="text-gray-400 text-xs sm:text-sm">Rufisque cité Senelec villa 237, Sénégal</span>
              </li>
            </ul>

            {/* Social */}
            <div className="flex gap-3 mt-4 sm:mt-6">
              <a href="#" className="w-9 h-9 sm:w-10 sm:h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-green-600 transition-all duration-300 hover:scale-110">
                <Linkedin size={16} />
              </a>
              <a href="#" className="w-9 h-9 sm:w-10 sm:h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-pink-600 transition-all duration-300 hover:scale-110">
                <Instagram size={16} />
              </a>
              <a href="#" className="w-9 h-9 sm:w-10 sm:h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-all duration-300 hover:scale-110">
                <Facebook size={16} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-800 mt-8 sm:mt-12 pt-6 sm:pt-8 flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4">
          <p className="text-gray-500 text-xs sm:text-sm text-center sm:text-left">
            © {new Date().getFullYear()} Barham Driver. Tous droits réservés.
          </p>
          <p className="text-gray-500 text-xs sm:text-sm">
            Partout au Sénégal 🇸🇳
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
